import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';

import { PUBLIC_API_BASE_PATH } from 'src/constants/environment';
import type { PartnerProductInsightsAPIPartner } from './types/PartnerProductInsightsAPIPartner';

export const PARTNER_INSIGHTS_API_PATH = `${PUBLIC_API_BASE_PATH}partner-insights`;

export const fetchPartnerInsightsClient = async (
  shortcode: string,
): Promise<PartnerProductInsightsAPIPartner | null> => {
  const response = await fetchJSONWithTimeout(
    `${PARTNER_INSIGHTS_API_PATH}/${encodeURIComponent(shortcode)}`,
  );

  if (!response.ok) {
    return null;
  }

  return response.json();
};
